/* 2C Bordados · filtros del catálogo (funcionan en la misma página, sin apps) */
(function () {
  function init(root) {
    if (root.dataset.tcReady) return;
    root.dataset.tcReady = '1';

    var grid = root.querySelector('[data-tc-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.tc-card'));
    var countEl = root.querySelector('[data-tc-count]');
    var emptyEl = root.querySelector('[data-tc-empty]');
    var state = { cat: 'todos', corte: 'todos', tec: 'todas', talla: '' };

    // Las categorías "PRÓXIMAMENTE" se activan solas cuando ya hay productos de esa categoría
    root.querySelectorAll('[data-tc-soon]').forEach(function (chip) {
      var key = chip.getAttribute('data-tc-soon');
      var has = cards.some(function (c) { return c.dataset.cat === key; });
      if (!has) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tc-chip';
      b.setAttribute('data-tc-cat', key);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = chip.firstChild ? chip.firstChild.textContent.trim() : key;
      chip.replaceWith(b);
    });

    // Ocultar grupos de filtros sin datos (p. ej. si ningún producto tiene tallas cargadas)
    var hasTallas = cards.some(function (c) { return (c.dataset.tallas || '').trim() !== ''; });
    var hasVinil = cards.some(function (c) { return c.dataset.vinil === 'true'; });
    var hasCorte = cards.some(function (c) { return (c.dataset.corte || '').trim() !== ''; });
    var g;
    if (!hasTallas && (g = root.querySelector('[data-tc-group="talla"]'))) g.hidden = true;
    if (!hasVinil && (g = root.querySelector('[data-tc-group="tec"]'))) g.hidden = true;
    if (!hasCorte && (g = root.querySelector('[data-tc-group="corte"]'))) g.hidden = true;

    function setPressed(selector, el) {
      root.querySelectorAll(selector).forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (state.cat !== 'todos' && c.dataset.cat !== state.cat) ok = false;
        if (ok && state.corte !== 'todos') {
          var cortes = (c.dataset.corte || '').split(' ');
          if (cortes.indexOf(state.corte) < 0) ok = false;
        }
        if (ok && state.tec === 'vinil' && c.dataset.vinil !== 'true') ok = false;
        if (ok && state.talla) {
          var t = (c.dataset.tallas || '').trim();
          if (t && (' ' + t + ' ').indexOf(' ' + state.talla + ' ') < 0) ok = false;
        }
        c.hidden = !ok;
        if (ok) n++;
      });
      grid.classList.toggle('is-cab', state.corte === 'caballero');
      if (countEl) countEl.textContent = n;
      if (emptyEl) emptyEl.hidden = n !== 0;
    }

    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-tc-cat]'))) {
        state.cat = b.getAttribute('data-tc-cat');
        setPressed('[data-tc-cat]', b);
        apply();
        try {
          var u = new URL(window.location.href);
          if (state.cat === 'todos') u.searchParams.delete('categoria');
          else u.searchParams.set('categoria', state.cat);
          history.replaceState(null, '', u.toString());
        } catch (err) {}
      } else if ((b = e.target.closest('[data-tc-corte]'))) {
        state.corte = b.getAttribute('data-tc-corte');
        setPressed('[data-tc-corte]', b);
        apply();
      } else if ((b = e.target.closest('[data-tc-tec]'))) {
        state.tec = b.getAttribute('data-tc-tec');
        setPressed('[data-tc-tec]', b);
        apply();
      } else if ((b = e.target.closest('[data-tc-talla]'))) {
        var t = b.getAttribute('data-tc-talla');
        state.talla = state.talla === t ? '' : t;
        setPressed('[data-tc-talla]', state.talla ? b : null);
        apply();
      } else if ((b = e.target.closest('[data-tc-filters-toggle]'))) {
        var open = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        root.classList.toggle('filters-open', open);
      }
    });

    var sort = root.querySelector('[data-tc-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var base = sort.getAttribute('data-tc-sort-base');
        var u = new URL(base || window.location.href, window.location.origin);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }

    // Preseleccionar categoría desde la dirección (?categoria=camisas)
    try {
      var pre = new URL(window.location.href).searchParams.get('categoria');
      if (pre) {
        var btn = root.querySelector('[data-tc-cat="' + pre.replace(/"/g, '') + '"]');
        if (btn) btn.click();
      }
    } catch (err) {}

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-tc-catalog]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
